<template>
    <div class="filter-row-inner flex-layout">
        <span class="filter-row-name">{{filterList.label}}:</span>
        <div class="filter-row-ul-wrapper">
            <ul class="filter-row-ul">
                <li class="filter-row-item csp" :class="{'active':active === 0}" @click="changeItem({value:0})">全部</li>
                <li v-for="(each,index) in filterList.children" :key="index" @click="changeItem(each)"
                    :class="{'active':active === each.value}" class="filter-row-item csp">
                    {{each.label}}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['filterList'],
        data() {
            return {
                active: 0,
                labelListMap:{
                    '学段':'priod',
                    '年级':'grade',
                    '学科':'subject',
                    '类型':'type',
                },
            }
        },
        methods: {
            changeItem(each) {
                let labelType
                if(each.label == '学科项目式学习' || each.label == '跨领域学习') {
                    labelType = 'type'
                } else {
                    labelType = this.labelListMap[this.filterList.label]
                }
                this.active = each.value;
                this.$emit('change', {
                    type: labelType,
                    val: each.value,
                  
                })
            },

        }
    }
</script>

<style lang="less" scoped>
    .filter-row-inner {
        .filter-row-name {
            min-width: 60px;
            line-height: 50px;
            color: #555;
        }

        .filter-row-ul-wrapper {
            // height: 50px;
            overflow: hidden;
            -webkit-transition: height .6s;
            -moz-transition: height .6s;
            -ms-transition: height .6s;
            -o-transition: height .6s;
            transition: height .6s;

            // &.unflod-row {
            //   height: 150px;
            // }
        }

        .filter-row-ul {
            flex-grow: 1;
        }

        .filter-row-item {
            display: inline-block;
            margin: 0 10px 0px 0;
            padding: 0 20px;
            line-height: 50px;
            color: #999;

            &.active {
                color: #508EF9;
            }
        }
    }
</style>